import { Instance } from 'mobx-state-tree';
import { ProjectRouteAddedDtoModelBase } from './ProjectRouteAddedDtoModel.base';

/* The TypeScript type of an instance of ProjectRouteAddedDtoModel */
export interface ProjectRouteAddedDtoModelType extends Instance<typeof ProjectRouteAddedDtoModel.Type> {}

/* A graphql query fragment builders for ProjectRouteAddedDtoModel */
export { selectFromProjectRouteAddedDto, projectRouteAddedDtoModelPrimitives, ProjectRouteAddedDtoModelSelector } from './ProjectRouteAddedDtoModel.base';

/**
 * ProjectRouteAddedDtoModel
 */
export const ProjectRouteAddedDtoModel = ProjectRouteAddedDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
